module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header text-center"
  }, [_vm._t("header", [_c('h1', [_vm._v("cc-pronto4")]), _vm._v(" "), _c('div', [_vm._v("powerd by assley")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.username),
      expression: "login.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "",
      "id": "username",
      "placeholder": "Username",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.login.username)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onLogin($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Passwort:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.password),
      expression: "login.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "Password",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.login.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onLogin($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "place"
    }
  }, [_vm._v("Platz/ACD-Login (optional):")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.place),
      expression: "login.place"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "",
      "id": "place",
      "placeholder": "Nebenstelle"
    },
    domProps: {
      "value": (_vm.login.place)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onLogin($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login, "place", $event.target.value)
      }
    }
  })])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errMsg),
      expression: "errMsg"
    }],
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.errMsg))]), _vm._v(" "), _vm._t("footer", [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.onLogin
    }
  }, [_vm._v("Login")])])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1eeda0d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Login.vue
// module id = 264
// module chunks = 0